import React from "react";
import ShareLink from "react-facebook-share-link";
import { FormattedMessage, useIntl } from "react-intl";

import changePlanCopy from "../../store/plan/actions/changePlanCopy";
import changePackPlanCopy from "../../store/pack/actions/changePackPlanCopy";

import routing from "../../routing";
import { ICheckboxEvent } from "../../types";

import Modal from "../Modal";
import Form, { InputText, Title, Label, FormElement, Cancel, Checkbox } from "../Form";


import messages from "./messages";
import { IProps } from "./interfaces";
import { useDispatch } from "react-redux";

const SharePlan = ({ plan, close }: IProps) => {
    const { formatMessage } = useIntl();
    const dispatch = useDispatch();
    const handleChangePlanCopy = (e: ICheckboxEvent) => {
        dispatch(changePlanCopy({ planId: plan._id, copyright: e.target.checked }, () => {
            dispatch(changePackPlanCopy({ planId: plan._id, copyright: e.target.checked }));
        }));
        
    };
    let shareLink = `${window?.location?.origin}/${routing.publicPlan}/${plan.publicId || plan._id}`;
    return (
        <Modal close={close}>
            <Form>
                <Title>
                    <FormattedMessage {...messages.title} />
                </Title>
                {plan.publicId && (
                    <Checkbox
                        label={formatMessage(messages.noCopy)}
                        checked={!!plan.copyright}
                        onChange={handleChangePlanCopy}
                    />
                )}
                <InputText
                    label={formatMessage(messages.link)}
                    selectAllOnClick
                    value={shareLink}
                    onChange={() => null}
                    copyOnClick
                />
                <FormElement>
                    <Label>
                        <FormattedMessage {...messages.social} />
                    </Label>
                    <div>
                        <ShareLink link={shareLink}>
                            {(link: string) => (
                                <a
                                    href={link}
                                    rel="noopener noreferrer"
                                    target="_blank"
                                    style={{ width: 170, display: "inline-block" }}
                                >
                                    <Cancel facebook onClick={() => null}>
                                        <FormattedMessage {...messages.facebook} />
                                    </Cancel>
                                </a>
                            )}
                        </ShareLink>
                    </div>
                </FormElement>
            </Form>
        </Modal>
    );
}

export default SharePlan;
